'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Alerts are used to inform users about important information, warnings, errors, or success.
 *
 * @example
 * <Alert data-color='info'>Dette er en informasjonsmelding</Alert>
 */
const Alert = forwardRef(function Alert({ 'data-color': color = 'info', className, ...rest }, ref) {
    return (jsx("div", { className: cl('ds-alert', className), "data-color": color, ref: ref, ...rest }));
});

export { Alert };
